import {BehaviorSubject} from 'rxjs';

export const AppStates = Object.freeze({
    IDLE: 0, // Nothing in particular
    EDITING: 1, // Edition mode
});

/**
 * Singleton class that control the App State
 */
class AppController {
    /**
     *
     */
    constructor() {
        this.currentState = AppStates.IDLE;
        this.refreshPRsListSubject = new BehaviorSubject(false);
    }

    /**
     *
     * @param {number} newState
     */
    setNewAppState(newState) {
        this.currentState = newState;
    };

    /**
     *
     * @return {number}
     */
    getCurrentAppState() {
        return this.currentState;
    };

    /**
     *
     */
    resetState() {
        this.currentState = AppStates.IDLE;
    };

    /**
     * Use this to refresh the PRs without using a Draw Event
     */
    refreshPRsList() {
        this.resetState();
        this.refreshPRsListSubject.next(true);
    }

    /**
     *
     * @return {BehaviorSubject}
     */
    getAppRefreshPRsListSubject() {
        return this.refreshPRsListSubject;
    }
}
// singleton
export default new AppController();
